module.exports = __webpack_public_path__ + "img/deployment.d4e9d232.svg";